import { FC } from 'react';

import { Box, css, Grid, styled } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';
import backChevronIcon from 'public/icons/back-chevron-icon.svg';

import { LocalePicker } from '@/components/locale-picker/locale-picker';
import { HEADER_HEIGHT, HEADER_MARGIN_BOTTOM } from '@/constants/ui.constants';

export interface HeaderProps {
  backToPath?: string | null;
  logo?: string;
  hasLocalePicker?: boolean;
  onBackClick?: () => void;
}

// logo size should be in 16:9 aspect ratio to look good
const LOGO_WIDTH = 46;
const LOGO_HEIGHT = 27;

export const Header: FC<HeaderProps> = ({
  backToPath = null,
  logo,
  onBackClick = () => null,
  hasLocalePicker
}) => (
  <Grid container mb={HEADER_MARGIN_BOTTOM / 2} height={HEADER_HEIGHT} alignItems="center">
    {backToPath && (
      <StyledLink href={backToPath}>
        <Image src={backChevronIcon} alt="Back" onClick={onBackClick} />
      </StyledLink>
    )}

    <Box ml="auto" display="flex" alignItems="center">
      {hasLocalePicker && <LocalePicker />}

      {logo && <StyledImage src={logo} width={LOGO_WIDTH} height={LOGO_HEIGHT} alt="Logo" />}
    </Box>
  </Grid>
);

const StyledLink = styled(Link)`
  display: flex;
`;

const StyledImage = styled(Image)(
  ({ theme }) => css`
    margin-left: ${theme.spacing(10)};
  `
);
